import { render, staticRenderFns } from "./health_notice_manbing.vue?vue&type=template&id=77aa878a&scoped=true&"
import script from "./health_notice_manbing.vue?vue&type=script&lang=js&"
export * from "./health_notice_manbing.vue?vue&type=script&lang=js&"
import style0 from "./health_notice_manbing.vue?vue&type=style&index=0&id=77aa878a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aa878a",
  null
  
)

export default component.exports